import { QueryOptionsType, Sliders } from '@framework/types';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
import { useQuery } from 'react-query';
export const fetchMainSliders = async ({
  queryKey
}: any) => {
  const [_key, _params] = queryKey;
  const {
    data
  } = await http.get(API_ENDPOINTS.MAIN_SLIDERS);
  return Array.isArray(data) ? data : [];
};
export const useMainSlidersQuery = (options: QueryOptionsType) => {
  return useQuery<Sliders[], Error>([API_ENDPOINTS.MAIN_SLIDERS, options], fetchMainSliders, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};